import { Component } from '@angular/core';
import { FormGroup, Validators, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';

import { CustomerService } from '@core/services/customer/customer.service';
import { ToastrService } from '@core/services/notification/toastr.service';
import { PonchoUIModule } from '@poncho/ui';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, PonchoUIModule]
})
export class ChangePasswordComponent {

    changePasswordForm: FormGroup;
    updatingPassword: boolean = false;

    constructor(
        private customerService: CustomerService,
        private toastrService: ToastrService,
        private dialogRef: MatDialogRef<ChangePasswordComponent>
    ) {
        this.changePasswordForm = new FormGroup({
            old_password: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6)
            ])),
            password: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6)
            ])),
            password_confirmation: new FormControl('', Validators.compose([
                Validators.required
            ]))
        }, { validators: this.passwordMatchValidator });
    }

    passwordMatchValidator(formGroup: FormGroup): { [key: string]: boolean } | null {
        const passwordControl = formGroup.get('password');
        const confirmPasswordControl = formGroup.get('password_confirmation');

        if (!passwordControl || !confirmPasswordControl) {
            return null;
        }
    
        if (confirmPasswordControl.errors && !confirmPasswordControl.errors['passwordMismatch']) {
            return null;
        }
    
        if (passwordControl.value !== confirmPasswordControl.value) {
            confirmPasswordControl.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true };
        } else {
            confirmPasswordControl.setErrors(null);
            return null;
        }
    }

    updatePassword(passwordDetails) {
        this.updatingPassword = true;
        this.customerService.updatePassword(passwordDetails).toPromise()
            .then((data: any) => {
                if (data && data.meta) {
                    if (data.meta.code === 200) {
                        this.dialogRef.close();
                    }
                    this.toastrService.openSnackBar(data.meta.message, 'OKAY');
                }
                this.updatingPassword = false;
            })
            .catch((error: any) => {
                this.updatingPassword = false;
                this.toastrService.openSnackBar(error?.meta?.message, 'OKAY');
            });
    }

    close() {
        this.dialogRef.close();
    }
}
